import AddToCartStandalone from '@kissui/components/src/add-to-cart-standalone'

class AddGiftCard extends AddToCartStandalone {
    performAddToCart(quantity) {
        const { sku, price } = this.props
        return window.CartManager.updateGiftCard(sku, quantity, price)
    }
}

customElements.get('nb-add-gift-card') || customElements.define('nb-add-gift-card', AddGiftCard)
export default AddGiftCard
